export default __webpack_public_path__ + "static/media/hk.7666a00e.jpg";